export const LOAD = 'LOAD_INQUIRY'
export const LOAD_ANSWER = 'LOAD_INQUIRY_ANSWER'
export const SET_STATUS = 'SET_INQUIRY_STATUS'
